import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export const useDeleteIntegration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (trackingId: string) => {
      await httpService.post(API_CONFIG.path.disconnectAccount, {
        trackingId,
      });
    },
    onSuccess: () => {
      // Invalidate and refetch integrations after successful deletion
      queryClient.invalidateQueries({ queryKey: ["integrations"] });
    },
  });
};
